import style from "./Bottom.module.css"
import arrow_bottom from "../../assets/images/arrow_bottom.png"
import qrcode from "../../assets/images/qrcode.png"
import map from "../../assets/images/map.png"
import AMapLoader from '@amap/amap-jsapi-loader';
import { useEffect, useState } from 'react';
import markericon from "../../assets/images/poi-marker-red.png"
import "./map.css"

export default function Main() {

  useEffect(() => {
    console.log("init map");
    AMapLoader.load({
      key: "d678b3109d581b9939f6e017e451288e",   // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0",              // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: [''],               // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    }).then((AMap) => {
      //var marker;
      var map = new AMap.Map("container", { //设置地图容器id
        //viewMode: "3D",         //是否为3D地图模式
        zoom: 15,                //初始化地图级别
        center: [120.708307, 27.991662], //初始化地图中心点位置
        resizeEnable: true,
      });
      var circle = new AMap.Circle({
        center: new AMap.LngLat("120.708307", "27.991662"), // 圆心位置
        radius: 30,  //半径
        strokeColor: "#F33",  //线颜色
        strokeOpacity: 1,  //线透明度
        strokeWeight: 3,  //线粗细度
        fillColor: "#ee2200",  //填充颜色
        fillOpacity: 0.35 //填充透明度
      });
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(25, 34),
        // 图标的取图地址
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
        // 图标所用图片大小
        imageSize: new AMap.Size(25, 34),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      });
      var marker = new AMap.Marker({
        icon: startIcon,
        position: [120.708307, 27.991662],
        //offset: new AMap.Pixel(-13, -30)
      });
      marker.setLabel({
        direction: 'top',
        offset: new AMap.Pixel(10, -9),  //设置文本标注偏移量
        content: "<div class='info'><img src='https://baohan.oss-cn-hangzhou.aliyuncs.com/map11.jpg' />浙江省温州市鹿城区市府路2号<br/>万麓园2幢鹿城国际大厦5楼 <span></span></div>", //设置文本标注内容
      });

      //console.log(marker);
      // marker.setMap(map);
      // console.log(marker, map);
      // map.add(marker);
      map.add([marker]);
    }).catch(e => {
      console.log(e);
    })

  }, []);
  return (
    <>
      <div className={style.bottomBox}>
        <h2>关注我们</h2>
        <img src={arrow_bottom} className={style.arrow} />
        <div className={style.qrcode}><img src={qrcode} /></div>

        <h2>公司地址</h2>
        <img src={arrow_bottom} className={style.arrow} />

        <div className={style.map} id="container"></div>
      </div>
    </>
  )
}